/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const updateNotificationPolicyBodyExpectedVersionExclusiveMin = 0;
export const updateNotificationPolicyBodyExpectedVersionMax = 9007199254740991;

export const updateNotificationPolicyBodyNameMax = 120;

export const updateNotificationPolicyBodyStepsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const updateNotificationPolicyBodyStepsItemPositionMin = 0;
export const updateNotificationPolicyBodyStepsItemPositionMax = 9007199254740991;

export const updateNotificationPolicyBodyStepsItemDelayMinutesMin = 0;
export const updateNotificationPolicyBodyStepsItemDelayMinutesMax = 1440;

export const updateNotificationPolicyBodyStepsItemTargetOneUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const updateNotificationPolicyBodyStepsItemTargetTwoScheduleIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const updateNotificationPolicyBodyStepsItemTargetThreeTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const updateNotificationPolicyBodyStepsItemChannelsMax = 3;

export const UpdateNotificationPolicyBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(updateNotificationPolicyBodyExpectedVersionExclusiveMin)
    .max(updateNotificationPolicyBodyExpectedVersionMax),
  name: zod.string().min(1).max(updateNotificationPolicyBodyNameMax),
  enabled: zod.boolean(),
  steps: zod
    .array(
      zod.object({
        id: zod.uuid().regex(updateNotificationPolicyBodyStepsItemIdRegExp),
        position: zod
          .int()
          .min(updateNotificationPolicyBodyStepsItemPositionMin)
          .max(updateNotificationPolicyBodyStepsItemPositionMax),
        delayMinutes: zod
          .int()
          .min(updateNotificationPolicyBodyStepsItemDelayMinutesMin)
          .max(updateNotificationPolicyBodyStepsItemDelayMinutesMax),
        condition: zod.enum(['not-acknowledged', 'not-resolved']),
        target: zod.union([
          zod.object({
            kind: zod.literal('user'),
            userId: zod.uuid().regex(updateNotificationPolicyBodyStepsItemTargetOneUserIdRegExp),
          }),
          zod.object({
            kind: zod.literal('schedule'),
            scheduleId: zod
              .uuid()
              .regex(updateNotificationPolicyBodyStepsItemTargetTwoScheduleIdRegExp),
          }),
          zod.object({
            kind: zod.literal('team'),
            teamId: zod.uuid().regex(updateNotificationPolicyBodyStepsItemTargetThreeTeamIdRegExp),
          }),
        ]),
        channels: zod
          .array(zod.enum(['email', 'sms', 'voice']))
          .min(1)
          .max(updateNotificationPolicyBodyStepsItemChannelsMax),
      }),
    )
    .min(1),
});

export type UpdateNotificationPolicyBody = zod.input<typeof UpdateNotificationPolicyBody>;
export type UpdateNotificationPolicyBodyOutput = zod.output<typeof UpdateNotificationPolicyBody>;
